import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/countDown/text.svg";
import { useSelector } from "react-redux";

const TextEditor = ({ value, onChange }) => {
  const { darkMode } = useSelector((state) => state.theme);

  function inputStyle() {
    const editor = document.querySelector(".ql-editor");
    if (editor) {
      editor.style.color = darkMode ? "#fff" : "#000";
    }
    const placeholder = document.querySelector(".ql-placeholder");
    if (placeholder) {
      placeholder.style.color = darkMode ? "#bbb" : "#999"; // Set placeholder text color based on dark mode
    }
    const border = document.querySelector(".quill");
    if (border) {
      border.style.borderColor = darkMode ? "#4D4D4D" : "#ddd"; // Set placeholder text color based on dark mode
    }
  }

  const quillModules = {
    toolbar: [
      //   ["bold", "italic", "underline", "strike", "blockquote"],
      ["bold", "italic", "underline", "strike"],
      [{ direction: "rtl" }],
      // [{ list: "ordered" }, { list: "bullet" }],
      //   ["link", "image"],
      [{ align: [] }],
      //   [{ color: [] }],
      //   ["code-block"],
      ["clean"],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "direction",
    "blockquote",
    "list",
    "bullet",
    "link",

    "image",
    "align",
    "color",
    "code-block",
  ];

  return (
    // <div className="relative">
    // <TextIcon className="absolute top-[10px] left-[10px] w-[18px] h-[18px]" />
    <ReactQuill
      style={inputStyle()}
      theme="snow"
      value={value}
      onChange={onChange}
      modules={quillModules}
      formats={quillFormats}
      // placeholder="Enter Text.."
    />
    // </div>
  );
};

export default TextEditor;
